import {type FormEvent, useState} from 'react';

import {PaperButton} from '../../shared/sticker/stickers';

const CODE_LENGTH = 4;

export const CodeEntry = ({
    notFound = false,
    onSubmit,
}: {
    notFound?: boolean;
    onSubmit: (code: string) => void;
}) => {
    const [value, setValue] = useState('');
    const submit = (event: FormEvent) => {
        event.preventDefault();
        if (value.length === CODE_LENGTH) onSubmit(value);
    };

    return (
        <main className="ph-page ph-page--entry">
            <form className="ph-stack ph-center" onSubmit={submit}>
                <p className="ph-brand">
                    Stack<em>TheBallot</em>
                </p>
                <h1 className="ph-title">Enter the code on screen</h1>
                <label className="ph-codebox">
                    <span className="ph-visually-hidden">Vote code</span>
                    <input
                        className="ph-codebox__input"
                        inputMode="text"
                        autoCapitalize="characters"
                        autoComplete="off"
                        autoCorrect="off"
                        spellCheck={false}
                        maxLength={CODE_LENGTH}
                        value={value}
                        onChange={(e) =>
                            setValue(e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, ''))
                        }
                    />
                    {Array.from({length: CODE_LENGTH}, (_unused, index) => (
                        // biome-ignore lint/suspicious/noArrayIndexKey: four fixed boxes
                        <span key={index} className="ph-codebox__cell" aria-hidden="true">
                            {value[index] ?? ''}
                        </span>
                    ))}
                </label>
                {notFound && (
                    <p className="ph-error" role="alert">
                        No vote with that code.
                    </p>
                )}
                <PaperButton
                    type="submit"
                    className="ph-wide"
                    disabled={value.length < CODE_LENGTH}
                >
                    Join
                </PaperButton>
            </form>
            {/* A full page load, so Cloudflare Access runs its sign-in for /admin. */}
            <p className="ph-signin">
                Running a vote? <a href="/admin">Sign in</a>
            </p>
        </main>
    );
};
